// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import ConnectionPointsIp from '@/app/modules/organizations/enums/ConnectionPointsIp';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import eventLogFields from '../../../fields/eventLogFields';
// Lang
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * @param root
 * @param root.cell
 * @returns {JSX} RenderEntryPort
 */
function RenderEntryPort({ cell }) {

    // Constants
    const entrySiteIp = getObjectAttributeFromStringKey(cell.row.original,
        generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.ENTRY_ADDRESS));
    const sslVersion = getObjectAttributeFromStringKey(cell.row.original,
        generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.SSL_VERSION));
    const originPort = getObjectAttributeFromStringKey(cell.row.original,
        generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.ORIGIN_PORT));
    const entryPort = getObjectAttributeFromStringKey(cell.row.original,
        generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.ENTRY_PORT));

    // Functions
    const getSite = (ipAddress) => {
        let siteLetterToDisplay = '';
        const siteLetter = Object.keys(ConnectionPointsIp)
            .find(site => ConnectionPointsIp[site].ip === ipAddress);
        if (siteLetter) {
            siteLetterToDisplay = ConnectionPointsIp[siteLetter].site;
        }
        return siteLetterToDisplay;
    };

    const site = entrySiteIp ? getSite(entrySiteIp) : null;

    // Render
    return (
        cell && cell.getValue(eventLogFields.NETWORK_INFORMATION.ENTRY_PORT.key) && sslVersion && originPort && entryPort && (originPort !== entryPort) ?
            <div>
                <div>
                    {cell.getValue(eventLogFields.NETWORK_INFORMATION.ENTRY_PORT.key)}
                </div>
                <div style={{ lineHeight: 1 }}>
                    <small>
                        {<Entity entity='entry_port.origin' namespace={nsTerminal} data={{ originEntryPort: originPort }} />}
                    </small>
                </div>
                <small>
                    {site ? `${sslVersion}.${site}` : sslVersion}
                </small>
            </div>
            : cell && cell.getValue(eventLogFields.NETWORK_INFORMATION.ENTRY_PORT.key) && sslVersion ?
                <div>
                    <div>
                        {cell.getValue(eventLogFields.NETWORK_INFORMATION.ENTRY_PORT.key)}
                    </div>
                    <small>
                        {site ? `${sslVersion}.${site}` : sslVersion}
                    </small>
                </div>
                : cell && cell.getValue(eventLogFields.NETWORK_INFORMATION.ENTRY_PORT.key) ?
                    <div>
                        {cell.getValue(eventLogFields.NETWORK_INFORMATION.ENTRY_PORT.key)}
                    </div>
                    : false
    );
}

RenderEntryPort.propTypes = {
    cell: PropTypes.object.isRequired
};

export default RenderEntryPort;